import withTheme from "../../hooks/withTheme";
import LoadError from "./LoadError";

export default withTheme(LoadError);
